<div class="report-action-container">
  <div class="left-side">
    Select date range :
    <mat-radio-group aria-label="Select an option" (change)="onChange($event)">
      <mat-radio-button value="{{DateGroupType.Year}}">Years</mat-radio-button>
      <mat-radio-button value="{{DateGroupType.Month}}" checked>Months</mat-radio-button>
      <mat-radio-button value="{{DateGroupType.Week}}">Weeks</mat-radio-button>
      <mat-radio-button value="{{DateGroupType.Day}}">Days</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="right-side">
    <button mat-flat-button [matMenuTriggerFor]="saveAsMenu">
      <mat-icon class="icon-button-override">save</mat-icon>
      Save As
    </button>
    <mat-menu #saveAsMenu>
      <button mat-menu-item (click)="saveImage()">
        <span>Image</span>
      </button>
      <button mat-menu-item (click)="savePDF()">
        <span>PDF</span>
      </button>
    </mat-menu>
  </div>
</div>
<core-patients-run-date #chart></core-patients-run-date>
